import { render } from "./SpellingPrintablesModal.vue?vue&type=template&id=4f50feb8&ts=true"
import script from "./SpellingPrintablesModal.vue?vue&type=script&lang=ts"
export * from "./SpellingPrintablesModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__